<merchant-products [store]="store" [merchantId]="merchantId"></merchant-products>
